import { useMutation, useQueryClient } from "@tanstack/react-query";
import * as Sentry from "@sentry/react";
import toast from "react-hot-toast";
import { supabase } from "../../lib/supabase";
import { invalidateSharingQueries } from "../../lib/invalidateSharing";

// Remove (CONTEXT.md): an Owner ending somebody else's membership. The same
// call also cancels an unanswered Invitation — list_members' DELETE policy
// doesn't distinguish by status, and there's no separate verb for "the
// Owner takes back an Invitation they haven't heard back on" — the manage
// panel just labels the button "Cancel" for an invited row and "Remove"
// for an accepted one.
export function useRemoveListMember() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      listId,
      userId,
    }: {
      listId: string;
      userId: string;
    }): Promise<void> => {
      const { error } = await supabase
        .from("list_members")
        .delete()
        .eq("list_id", listId)
        .eq("user_id", userId);
      if (error) throw error;
    },

    onSuccess: (_result, { listId }) => {
      invalidateSharingQueries(queryClient, listId);
    },

    onError: (err) => {
      Sentry.captureException(err, { extra: { mutation: "useRemoveListMember" } });
      toast.error("Couldn't save that. Please try again.");
    },
  });
}
